<script setup lang="ts">
import type { EsProductFragment } from '#graphql-operations'

defineProps<{
  product: EsProductFragment
}>()
</script>

<template>
  <template v-if="product?.saleLabel?.length">
    <ProductLabel
      v-for="label in product?.saleLabel"
      :key="label?.label"
      :label="label"
    />
  </template>
</template>

<style>
@import url("~layers/components/Product/Labels.css");
</style>
